import { AppScope } from "../types";

class UnhandledScopeError extends Error {
    constructor(scope: AppScope) {
        super(`Unhandled scope for view/action: ${scope}`);
    }
}

export { UnhandledScopeError };
